// src/theme/media.ts
// styled-components media-query helpers, single-sourced from breakpoints.ts.
// Usage:  ${media.mobile`grid-template-columns: 1fr;`}
import { css, type Interpolation } from 'styled-components';
import { query, type MediaQueryKey } from './breakpoints';

type TemplateArgs = [TemplateStringsArray, ...Interpolation<object>[]];

function wrap(key: MediaQueryKey) {
  return (...args: TemplateArgs) => css`
    @media ${query[key]} {
      ${css(...args)}
    }
  `;
}

export const media = {
  mobile: wrap('mobile'),
  tabletDown: wrap('tabletDown'),
  tabletUp: wrap('tabletUp'),
  desktop: wrap('desktop'),
} satisfies Record<MediaQueryKey, unknown>;
